import RoleHome from '../RoleHome';

export default function KitchenStaffPage() {
  return (
    <RoleHome
      title="Kitchen staff"
      description="Meal plans, diet visibility, and kitchen inventory."
    />
  );
}
